import { render, staticRenderFns } from "./navbar4.vue?vue&type=template&id=237862ea&scoped=true"
import script from "./navbar4.vue?vue&type=script&lang=js"
export * from "./navbar4.vue?vue&type=script&lang=js"
import style0 from "./navbar4.vue?vue&type=style&index=0&id=237862ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237862ea",
  null
  
)

export default component.exports